<script lang="ts">
    // Tout ceci ne sert que pour Chrome et Safari.
    // Firefox a déjà tout ce qu’il faut en CSS pour que le background en progress
    // soit correctement setté.

    // On calcule simplement un %, et on set une variable CSS en conséquence.
    // Le CSS devrait utiliser ça pour positionner le background dans chrome.

    interface Props {
        min?: number
        max?: number
        step?: number
        value?: number
        id: string
        disabled?: boolean
        oninput?: (v) => void
        onchange?: (v) => void
    }

    let { min = undefined, max = undefined, step = 1, value = $bindable(undefined), id, disabled = false, oninput = (v) => {}, onchange = (v) => {} }: Props = $props()

    let me: any = $state()

    $effect(() => {
        if (me) me.style.setProperty('--webkit-progress-pct', `${min != null && max != null && value != null && min != max ? (value * 100) / (max - min) : 0}%`)
    })
</script>

<input
    type="range"
    {id}
    bind:value
    {min}
    {max}
    {step}
    bind:this={me}
    {disabled}
    oninput={(e) => {
        oninput(value)
    }}
    onchange={(e) => {
        onchange(value)
    }}
/>
